import { METER_IDENTIFIER_KINDS, type NormalizedMeterIdentifier } from '@/shared/meter-identification-types';

const DEV_EUI_PATTERN = /^[0-9A-F]{16}$/;
const IMSI_PATTERN = /^[0-9]{14,15}$/;

export function normalizeMeterIdentifier(rawValue: string): NormalizedMeterIdentifier {
  const trimmed = rawValue.trim();
  const compact = trimmed.replace(/[\s:_-]/g, '');
  const upperCompact = compact.toUpperCase();

  if (DEV_EUI_PATTERN.test(upperCompact) && /[A-F]/.test(upperCompact)) {
    return {
      rawValue,
      normalizedValue: upperCompact,
      kind: METER_IDENTIFIER_KINDS.devEui,
    };
  }

  if (IMSI_PATTERN.test(compact)) {
    return {
      rawValue,
      normalizedValue: compact,
      kind: METER_IDENTIFIER_KINDS.imsi,
    };
  }

  if (upperCompact.startsWith('API')) {
    return {
      rawValue,
      normalizedValue: upperCompact,
      kind: METER_IDENTIFIER_KINDS.apiKey,
    };
  }

  if (upperCompact.length > 0) {
    return {
      rawValue,
      normalizedValue: upperCompact,
      kind: METER_IDENTIFIER_KINDS.serial,
    };
  }

  return {
    rawValue,
    normalizedValue: '',
    kind: METER_IDENTIFIER_KINDS.unknown,
  };
}

export function normalizeSearchField(value: string | null | undefined) {
  return value ? value.replace(/[\s:_-]/g, '').toUpperCase() : undefined;
}
